const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 130px)',
  },
  header: {
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #DFE2E5',
  },
  title: {
    fontSize: 18,
  },
}
export default styles
